import { render, staticRenderFns } from "./GerenciarLogs.vue?vue&type=template&id=6c04047d&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarLogs.vue?vue&type=style&index=0&id=6c04047d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c04047d",
  null
  
)

export default component.exports